let currentAudio = null;

export function requestAudioPlay(audioEl) {
  if (currentAudio && currentAudio !== audioEl) {
    // Pause the previous audio, but do NOT rewind it.
    // Scored ear-training audio can then resume without consuming a new listen.
    currentAudio.pause();
  }
  currentAudio = audioEl;
}

export function releaseAudio(audioEl) {
  if (currentAudio === audioEl) {
    currentAudio = null;
  }
}

export function stopCurrentAudio() {
  if (!currentAudio) return;
  currentAudio.pause();
  currentAudio.currentTime = 0;
  currentAudio = null;
}
